import { Modal } from '@components/Modal';
import { Button, Typography, WarningIcon } from '@gurupay/gp-ui-library';
import type { FC } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { BlockerFunction } from 'react-router-dom';
import { useBlocker } from 'react-router-dom';

interface FormBlockerProps {
	hasChanges?: boolean;
	descriptionKey?: string;
}

export const FormBlocker: FC<FormBlockerProps> = ({
	hasChanges,
	descriptionKey = 'paymentDescription',
}) => {
	const { t } = useTranslation(undefined, { keyPrefix: 'blocker' });
	const onRouteChangeStart = useCallback<BlockerFunction>(
		({ currentLocation, nextLocation }) =>
			Boolean(hasChanges) && currentLocation.pathname !== nextLocation.pathname,
		[hasChanges],
	);
	const blocker = useBlocker(onRouteChangeStart);

	if (blocker.state !== 'blocked') {
		return null;
	}

	return (
		<Modal className="space-y-space-24 text-center" isOpened>
			<div className="inline-block p-space-16 rounded-full border border-status-warning-300 bg-status-warning-50">
				<WarningIcon className="text-status-warning-500" />
			</div>
			<div className="space-y-space-4">
				<Typography level="h2">{t('title')}</Typography>
				<Typography level="text">{t(descriptionKey)}</Typography>
			</div>
			<div className="space-y-space-8">
				<Button className="w-full" onClick={blocker.reset} variant="primary-black">
					{t('stay')}
				</Button>
				<Button className="w-full" onClick={blocker.proceed} variant="secondary">
					{t('leave')}
				</Button>
			</div>
		</Modal>
	);
};
